import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgEmojiArc = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 15.25q3 1.5 6 0M10 8v3m4-3v3m7 1c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9" }))); };

export { SvgEmojiArc as default };
//# sourceMappingURL=emoji-arc.js.map
